import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { LandingPageService } from '../services/landingpage.service';
import { Router } from '@angular/router';
import { CruiseService } from '../services/cruise.service';

declare var $: any;

@Component({
  selector: 'app-exclusiveDeals',
  templateUrl: './exclusiveDeals.component.html',
  styleUrls: ['./exclusiveDeals.component.css']
})
export class ExclusiveComponent {
  title = 'Cruize';
  exclusiveDeals: any[]; sailMonths: any[];
  cruiseItinery: any[]; loginType: any = 'B2C';
  internationaCruises: any[]; domecticCruises: any[]; cruiselineCruises: any[]; internationHeading: any[]; cruiselineHeading: any[];
  countries: string[] = ["ASIA", "EUROPE", "MIDDLE EAST", "CARIBBEAN", "AUSTRALIA"];
  domesticCruise: any[]; travelstoriesCruises: any[]; trendingCruises: any[];
  cruiseLines: any[];
  travelStories: any[]; cruiseOffers: any[];
  cruiseMonths: any[]; Cruisedata: any = [];
  constructor(private landingPageService: LandingPageService, private toastr: ToastrService, private router: Router, private cruiserService: CruiseService) {
    this.loginType = this.cruiserService.getloginType();
    this.getcruiselineHeading(); this.getinternationalHeading();
    this.getExclusiveDeals("Exclusive Deals");
    //this.getInternationalCruise("continent", "", "");
    //this.getcruiselineCruise("cruise", "");
    this.getcruiseOffersMonths(); this.getDomesticCruise(); this.getTravelStoriesCruise("Travel Stories"); this.getTrendingCruise("trending");
  }
  activeContinent = '';
  activeCruise = '';
  activeCruiseLine = '';

  ngOnInit() {

    setTimeout(() => {
      $('.owl-carousel.bottom-slider').owlCarousel({
        margin: 30,
        autoplay: true,
        autoplayTimeout: 4500,
        lazyLoad: true,
        nav: true,
        navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
        responsive: {
          0: { items: 1, },
          576: { items: 2, },
          800: { items: 3, },
          992: { items: 4, }
        }
      });
    }, 1000);
  }

  bookNow(ed) {
    console.log(ed);
    this.router.navigate([ed]);
  }

  getCruiseDetails(cruise, type) {
    var qstring = "";
    if (type == 'trending') {
      qstring = cruise;
      this.router.navigate(["/" + qstring]);
    }
    else if (type == 'international' || type == 'domestic' || type == 'cruiseline') {
      qstring = "---------" + "" + "---" + cruise;
      this.router.navigate(["availbility/" + qstring.toLowerCase()]);
    }

    console.log(cruise);
  }

  getExclusiveDeals(cruise) {
    this.landingPageService.getTravelStoriesCruise(cruise, "").subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == 'success') {
          this.exclusiveDeals = resp.externalMaster;
          setTimeout(() => {
            $('.owl-carousel.banner').owlCarousel({
              margin: 30,
              autoplay: true,
              autoplayTimeout: 4500,
              lazyLoad: true,
              nav: true,
              navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
              responsive: {
                0: { items: 1, },
                576: { items: 1, },
                768: { items: 2, },
                992: { items: 3, }
              }
            });
          }, 500);
        }
      },
      error => {
        console.log(error);
      }
    )
  }

  getInternationalCruise(cruise, continent, cruiseline) {
    this.activeContinent = continent;
    this.landingPageService.getInternationalCruise(cruise, continent, cruiseline).subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == 'success') {
          this.internationaCruises = resp.cruiseMaster;
          //if (cruise != 'continent') {
          $('#internationaCruise').owlCarousel({
            touchDrag: false,
            mouseDrag: false
          });
          $('#internationaCruise').data('owl.carousel').destroy();
          //}
          setTimeout(() => {
            $('#internationaCruise').owlCarousel({
              margin: 30,
              autoplay: true,
              autoplayTimeout: 4500,
              lazyLoad: true,
              nav: true,
              navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
              responsive: {
                0: { items: 1, },
                576: { items: 2, },
                800: { items: 3, },
                992: { items: 4, }
              }
            });
          }, 50);
        }
      }, error => {
        console.log(error);
      }
    )
  }
  getcruiseOffersMonths() {
    this.landingPageService.getCruiseMonths("", "months").subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == 'success') {
          this.cruiseMonths = resp.months;
          this.getcruiselineOffers(this.cruiseMonths[0].month, "get")
        }
      }, error => {
        console.log(error);
      }
    )
  }
  getcruiselineOffers(cruise, cruiseline) {
    this.activeCruiseLine = cruiseline;
    this.landingPageService.getCruiseMonths(cruise, cruiseline).subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == 'success') {
          this.cruiseOffers = resp.cruiseMaster;
          $('#cruiseOffer').owlCarousel({
            touchDrag: false,
            mouseDrag: false
          });
          $('#cruiseOffer').data('owl.carousel').destroy();
          setTimeout(() => {
            $('#cruiseOffer').owlCarousel({
              margin: 30,
              autoplay: true,
              autoplayTimeout: 4500,
              lazyLoad: true,
              nav: true,
              navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
              responsive: {
                0: { items: 1, },
                576: { items: 2, },
                800: { items: 3, },
                992: { items: 4, }
              }
            });
          }, 50);
        }
      }, error => {
        console.log(error);
      }
    )
  }
  getOffers(destina) {
    this.Cruisedata = JSON.parse(destina.Offer);
  }
  getDomesticCruise() {
    this.landingPageService.getInternationalCruise("cruise", "Indian subcontinent", "").subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == 'success') {
          this.domecticCruises = resp.cruiseMaster;
        }
      }, error => {
        console.log(error);
      }
    )
  }

  getcruiselineCruise(cruise, cruiseline) {
    this.activeCruiseLine = cruiseline;
    this.landingPageService.getInternationalCruise(cruise, "", cruiseline).subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == 'success') {
          this.cruiselineCruises = resp.cruiseMaster;
          if (cruise != 'continent') {
            $('#cruiselinecarousel').owlCarousel({
              touchDrag: false,
              mouseDrag: false
            });
            $('#cruiselinecarousel').data('owl.carousel').destroy();
          }
          setTimeout(() => {
            $('#cruiselinecarousel').owlCarousel({
              margin: 30,
              autoplay: true,
              autoplayTimeout: 4500,
              lazyLoad: true,
              nav: true,
              navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
              responsive: {
                0: { items: 1, },
                576: { items: 2, },
                800: { items: 3, },
                992: { items: 4, }
              }
            });
          }, 50);
        }
      }, error => {
        console.log(error);
      }
    )
  }

  getcruiselineHeading() {
    this.landingPageService.getCruiseHeading("cruiseline").subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == 'success') {
          this.cruiselineHeading = resp.cruiseHeading;
          this.getcruiselineCruise("cruise", this.cruiselineHeading[0].heading)
        }
      }, error => {
        console.log(error);
      }
    )
  }

  getinternationalHeading() {
    this.landingPageService.getCruiseHeading("international").subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == 'success') {
          this.internationHeading = resp.cruiseHeading;
          this.activeContinent = this.internationHeading[0].heading;
          this.getInternationalCruise("continent", this.internationHeading[0].heading, "");
        }
      }, error => {
        console.log(error);
      }
    )
  }

  getTravelStoriesCruise(cruise) {
    this.landingPageService.getTravelStoriesCruise(cruise, "").subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == 'success') {
          this.travelstoriesCruises = resp.externalMaster;
          setTimeout(() => {
            $('.owl-carousel.travel-stories').owlCarousel({
              margin: 30,
              autoplay: true,
              autoplayTimeout: 4500,
              lazyLoad: true,
              nav: true,
              navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
              responsive: {
                0: { items: 1, },
                576: { items: 2, },
                800: { items: 3, },
                992: { items: 4, }
              }
            });
          }, 500);
        }
      }, error => {
        console.log(error);
      }
    )
  }

  getTrendingCruise(cruise) {
    this.landingPageService.getTrendingCruise(cruise, "").subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == 'success') {
          this.trendingCruises = resp.cruiseMaster;
          setTimeout(() => {
            $('.owl-carousel.trending_cruise').owlCarousel({
              margin: 30,
              autoplay: true,
              autoplayTimeout: 4500,
              lazyLoad: true,
              nav: true,
              navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
              responsive: {
                0: { items: 1, },
                576: { items: 2, },
                800: { items: 3, },
                992: { items: 4, }
              }
            });
          }, 500);
        }
      }, error => {
        console.log(error);
      }
    )
  }

}
